import './Sprint.css'
import { getWeekdayFromSprintProgress } from '../helper/HelperFunctions';

interface iSprint {
    sprintNumber: number;
    sprintProgress: number;
    startSprintCallback: () => void;
}

export default function Sprint(props: iSprint) {

    return (
            props.sprintProgress === 0 ? 
                <div className='sprint-planning'>       
                    <div className='sprint-planning-text'>
                        {props.sprintNumber === 0 && <p><strong>Plan your first sprint</strong></p>}
                        {props.sprintNumber !== 0 && <p>Plan your next sprint</p>}
                    </div>
                    <button
                        className='action-button'
                        onClick={props.startSprintCallback}
                    >
                        <span style={{ marginRight: '8px' }}>▶️</span>
                        Start Sprint
                    </button>
                </div>
            :
                <div className='sprint-progress'>
                    <div>
                        <p>Sprint {props.sprintNumber}</p>
                    </div>
                    <div>
                        <p>Progress: {getWeekdayFromSprintProgress(props.sprintProgress)}</p>
                        <progress value={props.sprintProgress} max={10}></progress>
                    </div>
                </div>  
    );
}